import * as React from "react"

import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { FieldItems, Input } from "@tenforce/toolbox-field-react"

import { Symbols } from "@tenforce/toolbox-fontmap"
import { connect } from "react-redux"
import { mapDispatchToProps, DispatchProps } from "../../../bookmarks/actions"
import { Labels } from "../../../../util/Translations"
import { Bookmark } from "../../../../models"

// NOTE: hardcoded to avoid extra calls to backend
const BOOKMARK_TITLE_MAX_LENGTH = 255

interface OwnProps {
    bookmark: Bookmark
    tileId: number
    removeTile: (tileId: number) => void
}

type Props = OwnProps & DispatchProps

interface State {
    title: string
}

export class BookmarkConfigWidget extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            title: props.bookmark.title,
        }
    }

    render(): JSX.Element {
        const { title } = this.state
        const { Bookmark, PleaseEnterATitle, RemoveBookmark } = Labels

        return (
            <>
                <h3 className="tw-mr-2 is-dimmed">{Symbols.BookmarkEmpty}</h3>
                <div className="tw-flex-1">
                    <div className="label is-dimmed">{Bookmark}</div>
                    <FieldItems extraClasses="tw-flex-1">
                        <Input
                            maxLength={BOOKMARK_TITLE_MAX_LENGTH}
                            placeholder={PleaseEnterATitle}
                            required={true}
                            value={title}
                            title={title}
                            onBlur={this.saveBookmarkTitle}
                            onChangedValue={(value): void =>
                                this.setState({ title: value })
                            }
                            onKeyUp={this.onKeyUp}
                        />
                    </FieldItems>
                </div>
                <div className="is-hidden-action">
                    <Action
                        onClick={this.removeBookmark}
                        title={RemoveBookmark}
                        actionType={ActionType.icon}
                        data-ft-remove
                    >
                        {Symbols.Delete}
                    </Action>
                </div>
            </>
        )
    }

    onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>): void => {
        if (event.key === "Enter") {
            event.currentTarget.blur()
        }
    }

    removeBookmark = (): void => {
        const {
            bookmark: { bookmarkId },
            tileId,
            removeBookmark,
            removeTile,
        } = this.props
        removeBookmark(bookmarkId)
        removeTile(tileId)
    }

    saveBookmarkTitle = (): void => {
        const { saveBookmarkTitle, bookmark } = this.props
        const { title: originalTitle } = bookmark
        let { title: newTitle } = this.state
        newTitle = newTitle.trim()

        if (newTitle.length === 0) {
            this.setState({ title: originalTitle })
            return
        }
        if (newTitle !== originalTitle) {
            saveBookmarkTitle({ ...bookmark, title: newTitle })
        }
    }
}

export default connect(null, mapDispatchToProps)(BookmarkConfigWidget)
